import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Progress from 'reactstrap/lib/Progress';
import Media from 'reactstrap/lib/Media';

import stepupImg from '../../../images/stepup.webp';
import {
  sendLanguage
} from '../../../constants/constants';
import { renderNum } from '../../../utils/stringUtils';

class LevelProgress extends React.Component {
  static propTypes = {
    member: PropTypes.shape({
      level: PropTypes.number,
      levelupGameLimit: PropTypes.number,
      gamesPlayed: PropTypes.number,
      totalPoints: PropTypes.number,
      uid: PropTypes.string,
      status: PropTypes.string,
    }).isRequired,
    t: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      pointsProgressBar: 0,
      gamesProgressBar: 0,
      pointsProgress: 0,
      gamesProgress: 0,
    };
  }

  componentDidMount() {
    const { member } = this.props;
    const {
      level,
      levelupGameLimit,
      gamesPlayed,
      totalPoints,
      lvlupLimit,
      totalPnts,
    } = member;

    let lastGameLimit;

    if (level === 1) {
      lastGameLimit = 0;
    } else if (level === 2) {
      lastGameLimit = 5;
    } else if (level === 3) {
      lastGameLimit = 10;
    } else if (level === 4) {
      lastGameLimit = 20;
    } else {
      lastGameLimit = levelupGameLimit / 1.2;
    }

    let pointsProgress;
    let gamesProgress;
    let pointsToNextLvl;
    let gamesToNextLvl;

    /*
    if (level === 1) {
      gamesProgress = (gamesPlayed) / (5) * 100;
      gamesToNextLvl = 5 - gamesPlayed;
    } else {
      gamesProgress = (gamesPlayed - lastGameLimit) / (levelupGameLimit - lastGameLimit) * 100;
      gamesToNextLvl = levelupGameLimit - gamesPlayed;
    }
    if (level > 2) {
      pointsProgress = (totalPoints) / (((level - 3) * 5) + 10) * 100;
      pointsToNextLvl = (((level - 3) * 5) + 10) - totalPoints;
    } else {
      pointsProgress = 100;
      pointsToNextLvl = 0;
    } */

    const lvlUpdateResp = this.calculateLvlPorgress(level, lvlupLimit, gamesPlayed, totalPnts);

    // console.log('lvlUpdateResp', lvlUpdateResp, pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl);

    const { gamesPlayedPercentClamped, gamesPlayedToLevelUp, pointsPercentClamped, pointsToLevelUp } = lvlUpdateResp;

    gamesProgress = gamesPlayedPercentClamped;
    gamesToNextLvl = gamesPlayedToLevelUp;
    pointsProgress = pointsPercentClamped;
    pointsToNextLvl = pointsToLevelUp;

    this.UpdateProgress(pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl);
  }

  componentDidUpdate(_prevProps, prevState) {
    const pointsProgressOld = prevState.pointsProgress;
    const gamesProgressOld = prevState.gamesProgress;

    const { member } = this.props;
    const {
      level,
      levelupGameLimit,
      gamesPlayed,
      totalPoints,
      lvlupLimit,
      totalPnts,
    } = member;

    console.log('member', member);

    if (member && member.status !== 'signedOut' && member.uid) {
      let lastGameLimit;

      if (level === 1) {
        lastGameLimit = 0;
      } else if (level === 2) {
        lastGameLimit = 5;
      } else if (level === 3) {
        lastGameLimit = 10;
      } else if (level === 4) {
        lastGameLimit = 20;
      } else {
        lastGameLimit = levelupGameLimit / 1.2;
      }

      let pointsProgress;
      let gamesProgress;
      let pointsToNextLvl;
      let gamesToNextLvl;

      /* if (level === 1) {
        gamesProgress = (gamesPlayed) / (5) * 100;
        gamesToNextLvl = 5 - gamesPlayed;
      } else {
        if (levelupGameLimit) {
          gamesProgress = (gamesPlayed - lastGameLimit) / (levelupGameLimit - lastGameLimit) * 100;
          gamesToNextLvl = levelupGameLimit - gamesPlayed;
        } else {
          if (level === 3) {
            gamesProgress = (gamesPlayed - lastGameLimit) / (20 - lastGameLimit) * 100;
            gamesToNextLvl = 20 - gamesPlayed;
          } else {
            gamesProgress = (gamesPlayed - lastGameLimit) / ((lastGameLimit * 2) - lastGameLimit) * 100;
            gamesToNextLvl = (lastGameLimit * 2) - gamesPlayed;
          }
        }
      }
      if (level > 2) {
        pointsProgress = (totalPoints) / (((level - 3) * 5) + 10) * 100;
        pointsToNextLvl = (((level - 3) * 5) + 10) - totalPoints;
      } else {
        pointsProgress = 100;
        pointsToNextLvl = 0;
      } */

      const lvlUpdateResp = this.calculateLvlPorgress(level, lvlupLimit, gamesPlayed, totalPnts);

      // console.log('lvlUpdateResp', lvlUpdateResp, pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl);

      const { gamesPlayedPercentClamped, gamesPlayedToLevelUp, pointsPercentClamped, pointsToLevelUp } = lvlUpdateResp;

      gamesProgress = gamesPlayedPercentClamped;
      gamesToNextLvl = gamesPlayedToLevelUp;
      pointsProgress = pointsPercentClamped;
      pointsToNextLvl = pointsToLevelUp;

      if ((pointsProgress && pointsProgressOld !== pointsProgress) || (gamesProgress && gamesProgressOld !== gamesProgress)) {
        this.UpdateProgress(pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl);
      }
    }
  }

  calculateLvlPorgress = (level, lvlupLimit, gamesPlayed, totalPnts) => {
    console.log('calculateLvlPorgress', level, lvlupLimit, gamesPlayed, totalPnts);

    let gamesPlayedForNextLvl;
    let gamesPlayedForCurrentLvl;
    let pointsForNextLvl;
    let pointsForCurrentLvl;

    if (level === 1) {
      gamesPlayedForNextLvl = 5;
      gamesPlayedForCurrentLvl = 0;

      pointsForNextLvl = 0;
      pointsForCurrentLvl = 0;

    } else if (level === 2) {
      gamesPlayedForNextLvl = 10;
      gamesPlayedForCurrentLvl = 5;

      pointsForNextLvl = 0;
      pointsForCurrentLvl = 0;
    } else if (level === 3) {
      gamesPlayedForNextLvl = 20;
      gamesPlayedForCurrentLvl = 10;

      pointsForNextLvl = 10;
      pointsForCurrentLvl = 0;
    } else if (level === 4) {
      gamesPlayedForNextLvl = 20;
      gamesPlayedForCurrentLvl = 10;

      pointsForNextLvl = 10;
      pointsForCurrentLvl = 10;
    } else {

      gamesPlayedForNextLvl = (lvlupLimit || 0);
      gamesPlayedForCurrentLvl = Math.round(gamesPlayedForNextLvl / 1.2);

      pointsForNextLvl = 10 + ((parseInt(level, 10) - 4) * 5);
      pointsForCurrentLvl = 10 + ((parseInt(level, 10) - 5) * 5);
    }

    let gamesPlayedToLevelUp = gamesPlayedForNextLvl - gamesPlayed;
    const pointsToLevelUp = pointsForNextLvl - totalPnts;

    if (gamesPlayedToLevelUp < 0) {
      gamesPlayedToLevelUp = 0;
    }

    const gamesPlayedDenominator = gamesPlayedToLevelUp;
    const gamesPlayedPercent = gamesPlayedDenominator === 0
      ? 100
      : ((gamesPlayed - gamesPlayedForCurrentLvl) / gamesPlayedDenominator) * 100;
    const gamesPlayedPercentClamped = Math.max(0, Math.min(100, gamesPlayedPercent));

    const pointsDenominator = pointsForNextLvl - pointsForCurrentLvl;
    const pointsPercent = pointsDenominator === 0
      ? 100
      : ((totalPnts - pointsForCurrentLvl) / pointsDenominator) * 100;
    const pointsPercentClamped = Math.max(0, Math.min(100, pointsPercent));

    const levelProgressPercent = (gamesPlayedPercentClamped + pointsPercentClamped) / 2;

    return ({ gamesPlayedPercentClamped, pointsPercentClamped, gamesPlayedForNextLvl, pointsForNextLvl, gamesPlayedToLevelUp, pointsToLevelUp });
  }

  UpdateProgress = (pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl) => {
    console.log('UpdateProgress', pointsProgress, gamesProgress, pointsToNextLvl, gamesToNextLvl);

    let pointsProgressBar;
    if (pointsProgress < 0) {
      pointsProgressBar = 10;
    } else if (pointsProgress > 100) {
      pointsProgressBar = 100;
    } else {
      pointsProgressBar = pointsProgress;
    }

    let gamesProgressBar;
    if (gamesProgress < 0) {
      gamesProgressBar = 10;
    } else if (gamesProgress > 100) {
      gamesProgressBar = 100;
    } else {
      gamesProgressBar = gamesProgress;
    }

    this.setState({
      pointsProgressBar, gamesProgressBar, pointsToNextLvl, gamesToNextLvl, pointsProgress, gamesProgress,
    });
  }

  render() {
    const { t, i18n } = this.props;

    const {
      pointsProgressBar, gamesProgressBar, pointsToNextLvl, gamesToNextLvl,
    } = this.state;

    return (
      <div>
        <Row className="levelProgress-text-row">
          <Col sm="12">
            <Fragment>

              {
                i18n.language === sendLanguage.en ? (
                  <>
                    <Fragment>
                      <div className="levelProgress-text-yellow">
                        {` ${gamesToNextLvl > 0 ? gamesToNextLvl : 0} `}
                        &nbsp;
                      </div>
                      {/* <div className="levelProgress-text">
                        {`${t('levelProgress.games')}`}
                      </div> */}
                    </Fragment>
                    <div className="levelProgress-text">
                      {`${t('levelProgress.untilNextRounds')} `}
                    </div>
                  </>
                ) : (
                  <>
                    <Fragment>
                      <div className="levelProgress-text">
                        {`${t('levelProgress.untilNextRounds')} `}
                        <div className="levelProgress-text-yellow mr-1 ml-1">
                          {` ${gamesToNextLvl > 0 ? gamesToNextLvl : 0} `}
                        </div>
                      </div>
                      {
                        i18n.language !== sendLanguage.ru && (
                          <div className="levelProgress-text">
                            {`${t('levelProgress.games')} `}
                          </div>
                        )
                      }
                      {/* <div className="levelProgress-text">
                        {`${t('levelProgress.points')}`}
                      </div> */}
                    </Fragment>

                  </>
                )
              }
            </Fragment>
          </Col>
        </Row>

        <div
          className="levelProgress"
        >
          <Progress
            color="success"
            value={gamesProgressBar}
            className="levelProgress-bar"
          >
            <span className="left-to-100" style={{ left: `${gamesProgressBar + (100 - gamesProgressBar) / 2}%` }}>{gamesToNextLvl}</span>

          </Progress>

          <Media className="stepup-img" src={stepupImg} style={{ left: `${gamesProgressBar}%` }} />
        </div>

        <Row className="levelProgress-text-row">
          <Col sm="12">
            <Fragment>
              {
                i18n.language === sendLanguage.en ? (
                  <>
                    <Fragment>
                      <div className="levelProgress-text-yellow">
                        {` ${pointsToNextLvl > 0 ? renderNum(pointsToNextLvl) : 0} `}
                        &nbsp;
                      </div>
                      {/* <div className="levelProgress-text">
                        {`${t('levelProgress.points')}`}
                      </div> */}
                    </Fragment>
                    <div className="levelProgress-text">
                      {`${t('levelProgress.untilNextPoints')} `}
                    </div>
                  </>
                ) : (
                  <>
                    <Fragment>
                      <div className="levelProgress-text">
                        {`${t('levelProgress.untilNextPoints')} `}
                        <div className="levelProgress-text-yellow mr-1 ml-1">
                          {` ${pointsToNextLvl > 0 ? renderNum(pointsToNextLvl) : 0} `}
                        </div>
                      </div>
                      {
                        i18n.language !== sendLanguage.ru && (
                          <div className="levelProgress-text">
                            {`${t('levelProgress.points')} `}
                          </div>
                        )
                      }
                      {/* <div className="levelProgress-text">
                        {`${t('levelProgress.points')}`}
                      </div> */}
                    </Fragment>

                  </>
                )
              }
            </Fragment>
          </Col>
        </Row>


        <div
          className="levelProgress"
        >
          <Progress
            color="success"
            value={pointsProgressBar}
            className="levelProgress-bar"
          >
            <span className="left-to-100" style={{ left: `${pointsProgressBar + (100 - pointsProgressBar) / 2}%` }}>{pointsToNextLvl}</span>
          </Progress>

          <Media className="stepup-img" src={stepupImg} style={{ left: `${pointsProgressBar}%` }} />

        </div>

      </div>
    );
  }
}


export default withTranslation('common')(LevelProgress);
